<template>
  <div class="app-bar-profile" v-on:click="profileMenuToggle" style="cursor: pointer">
    <v-avatar color="white" size="50" v-on:click="toggleMenu" style="border: 1px solid #f2f2f2 !important;">
      <img v-if="user.imageProfileUrl"
           :srcset="user.imageProfileUrl + '=c-w320, ' + user.imageProfileUrl + '=c-w480 1.5x, '+ user.imageProfileUrl + '=c-w640 2x'"
           :src="user.imageProfileUrl + '=c-w640'"
           :alt="user.nameFirstEN">
      <span style="color: black"  v-else-if="user.nameFirstEN">{{user.nameFirstEN.slice(0, 1)}}</span>
    </v-avatar>
    <div class="menu" v-if="openMenu">
      <ul>
<!--        <li>-->
<!--          ข้อมูล่วนตัว-->
<!--        </li>-->
        <li style="cursor: pointer" v-on:click="logout">
          ออกจากระบบ
        </li>
        <!--<li>การชำระเงิน</li>-->
      </ul>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'AppBarProfile',
  data: function() {
    return {
      openMenu: false
    }
  },
  computed: mapState({
    user: state => state.user.userData,
  }),
  created() {
    this.getUser()
  },
  methods: {
    getUser: function () {
      this.$store.dispatch('user/get')
    },
    profileMenuToggle: function () {
      this.$store.dispatch('drawer/toggleProfileMenu')
    },
    logout: function (){
      this.$store.dispatch('auth/logout')
    },
    toggleMenu: function() {
      this.openMenu = !this.openMenu;
    }
  }
}
</script>

<style scoped lang="scss">
  .app-bar-profile {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    position: relative;
    ul {
      margin: 0;
      padding: 0;
      li {
        list-style: none;
        padding: 5px 0;
      }
    }
    .menu {
      position: absolute;
      top: 60px;
      right: 0;
      width: 200px;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      padding: 25px 30px;
      border-top-right-radius: 40px;
      border-bottom-left-radius: 40px;
      background: #FFFFFF;
      z-index: 1;
    }
  }
</style>
